// Footgun-предупреждение про удаление роль-критичных инструментов из allow-list.
//
// Спека 03-agents/roles/overrides § «Per-(org, role) allow-list
// инструментов»: allow-list — primary least-privilege-механизм
// (footgun-семантика human-confirm — там же, в blacklist-разделе).
// Опасность здесь ИНВЕРТИРОВАНА относительно
// blacklist'а: убрать инструмент из allow-list'а можно лишить роль того, без
// чего она не работает (например, `Bash` у reviewer'а — нужен для прогона
// тестов/линтеров). Системной защиты нет: единственный барьер —
// подтверждение человеком в UI, поэтому модалка удаления ДОЛЖНА
// предупреждать о роль-критичных инструментах. Это не блокировка (убрать
// разрешение всё равно можно), а явное предупреждение.
//
// Список роль-критичных инструментов держим здесь чистой таблицей, чтобы
// юнитить решение напрямую (Mantine Modal/Select в jsdom неудобны) и
// переиспользовать в управляющей секции и в форме apply на /self-improvement.

// Инструменты, без которых роль фактически не способна выполнить работу.
// Сравнение по точному имени инструмента; роль — нормализуем регистром.
const ROLE_CRITICAL_TOOLS: Readonly<Record<string, readonly string[]>> = {
  // reviewer прогоняет тесты/линтеры через Bash — без него ревью неполноценно.
  reviewer: ["Bash"],
  // coder пишет код и коммитит — Write/Edit/Bash для него критичны.
  coder: ["Bash", "Write", "Edit"],
};

/**
 * Чистая проверка «убрать этот инструмент у этой роли из allow-list'а —
 * footgun?». Возвращает `true`, если инструмент входит в роль-критичный
 * набор роли — тогда снятие разрешения сломает роль. Регистр роли
 * нормализуем (Select отдаёт каноничное имя, но страхуемся); имя
 * инструмента сравниваем как есть (claude чувствителен к регистру).
 */
export function isRoleCriticalTool(
  roleName: string,
  toolName: string,
): boolean {
  const critical = ROLE_CRITICAL_TOOLS[roleName.trim().toLowerCase()] ?? [];
  return critical.includes(toolName.trim());
}
